/**
 * Збережений стан розгорнутих розділів лівого меню модуля: localStorage `po.menu.<модуль>.v1` → { ідентифікатор розділу: розгорнуто }.
 * Помилки сховища (приватний режим, заборона доступу, зіпсований JSON) ігноруються — стан тоді живе лише в пам'яті.
 */
const keyOf = (moduleKey: string): string => `po.menu.${moduleKey}.v1`;

/** Збережений стан модуля; лише булеві значення, інше відкидається. */
export function readMenuOpen(storage: Pick<Storage, 'getItem'> | undefined, moduleKey: string): Record<string, boolean> {
  try {
    const raw = storage?.getItem(keyOf(moduleKey));
    const value: unknown = raw ? JSON.parse(raw) : {};
    if (typeof value !== 'object' || value === null || Array.isArray(value)) return {};
    return Object.fromEntries(Object.entries(value).filter((e): e is [string, boolean] => typeof e[1] === 'boolean'));
  } catch {
    return {};
  }
}

export function writeMenuOpen(storage: Pick<Storage, 'setItem'> | undefined, moduleKey: string, state: Record<string, boolean>): void {
  try {
    storage?.setItem(keyOf(moduleKey), JSON.stringify(state));
  } catch {
    /* сховище недоступне — стан розділів живе лише в пам'яті компонента */
  }
}

/** localStorage браузера або undefined (тести в node, доступ заборонено політикою сайту). */
export function browserStorage(): Storage | undefined {
  try {
    return typeof localStorage === 'undefined' ? undefined : localStorage;
  } catch {
    return undefined;
  }
}
